export enum LocalStorageKeys {
    ACCESS_TOKEN = 'ACCESS_TOKEN',
    REFRESH_TOKEN = 'REFRESH_TOKEN',
    EXPIRES_IN = 'EXPIRES_IN',
    AUTHORITY = 'AUTHORITY',
}

export const userRoles = ['SILAdmin', 'SILUser']
